import { WarningCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconWarningCircle12Line = createIcon(WarningCircle, 12, "Line");
export const IconWarningCircle16Line = createIcon(WarningCircle, 16, "Line");
export const IconWarningCircle20Line = createIcon(WarningCircle, 20, "Line");
export const IconWarningCircle24Line = createIcon(WarningCircle, 24, "Line");
export const IconWarningCircle32Line = createIcon(WarningCircle, 32, "Line");
export const IconWarningCircle48Line = createIcon(WarningCircle, 48, "Line");
export const IconWarningCircle64Line = createIcon(WarningCircle, 64, "Line");
